import { FAQ } from "./components/FAQ";
import { LanguageProvider } from "./components/LanguageProvider";
import { MobileActionBar, SiteHeader } from "./components/SiteHeader";
import { SiteFooter } from "./components/SiteFooter";
import {
  AboutApril,
  Benefits,
  Conditions,
  FinalCTA,
  Hero,
  HowItWorks,
  NewClientOffer,
  ProblemStatement,
  ServiceArea,
  ServiceDetails,
  Testimonials,
  TreatmentExpectations,
} from "./components/Sections";

export default function App() {
  return (
    <LanguageProvider>
      <a className="skip-link" href="#main">Skip to main content</a>
      <SiteHeader />
      <main id="main">
        <Hero />
        <Benefits />
        <ProblemStatement />
        <Conditions />
        <ServiceDetails />
        <NewClientOffer />
        <HowItWorks />
        <AboutApril />
        <Testimonials />
        <TreatmentExpectations />
        <ServiceArea />
        <FAQ />
        <FinalCTA />
      </main>
      <SiteFooter />
      <MobileActionBar />
    </LanguageProvider>
  );
}
